import { useState } from 'react'
import { formatUnits } from 'ethers/lib/utils'
import { Token } from 'symbiosis-js-sdk'

import { Banner } from '~/components/Banner'
import Button from '~/components/Button'

import { CONFIG } from '~/lib/config'
import { renderAmount } from '~/lib/helpers'
import { useWallet } from '~/lib/useWallet'
import { getChainById } from '~/lib/config'

import { ClaimParams, Reward } from '../../hooks'

import styles from './BannerClaim.pcss'

interface Props {
	rewards: Reward[]
	onClaimClick: (params: ClaimParams) => void
	isClaiming: boolean
}

export function BannerClaim({ rewards, onClaimClick, isClaiming }: Props) {
	const [claimToken, setClaimToken] = useState<Token | undefined>(undefined)
	const wallet = useWallet()

	return (
		<Banner
			title="Extra rewards are available to claim:"
			hint="Extra rewards are one of the exclusive benefits for veSIS holders"
			showIcon={false}
		>
			{rewards.map((reward) => {
				const isEligible = reward.amount !== null
				const isWrongChain = !wallet.isCurrentChain(reward.chainId)
				const chainConfig = getChainById(reward.chainId)

				const rewardTokenData = CONFIG.rewardTokens.find((token) => {
					return (
						token.chainId === reward.chainId &&
						token.address.toLowerCase() ===
							reward.tokenAddress.toLowerCase()
					)
				})
				if (!rewardTokenData) {
					return
				}
				const rewardToken = new Token(rewardTokenData)

				const isClaimingItem =
					isClaiming &&
					isEligible &&
					claimToken &&
					claimToken.equals(rewardToken)

				let actionText = 'Claim'
				if (!isEligible) {
					actionText = 'Not eligible'
				} else if (isClaimingItem) {
					actionText = 'Claiming...'
				} else if (reward.amount === '0') {
					actionText = 'Claimed'
				}

				const isDisabledActionBtn =
					!isEligible || isClaimingItem || reward.amount === '0'
				const isSwitchChainBtn =
					isWrongChain && isEligible && reward.amount !== '0'

				return (
					<div
						className={styles.bannerClaimRow}
						key={`${reward.tokenAddress}-${reward.chainId}`}
					>
						<span className={styles.bannerClaimSum}>
							{isEligible &&
								renderAmount(
									formatUnits(
										reward.amount,
										rewardToken.decimals
									),
									3
								)}{' '}
							{rewardToken.symbol}
						</span>
						{isSwitchChainBtn ? (
							<Button
								className={styles.claimButton}
								onClick={() => {
									wallet.setChain(reward.chainId)
								}}
							>
								Switch to {chainConfig?.name}
							</Button>
						) : (
							<Button
								className={styles.claimButton}
								onClick={() => {
									setClaimToken(rewardToken)
									onClaimClick({
										index: reward.proofIndex,
										merkleProofs: reward.proofs,
										amount: reward.amount,
										tokenAddress: reward.tokenAddress,
									})
								}}
								disabled={isDisabledActionBtn}
							>
								{actionText}
							</Button>
						)}
					</div>
				)
			})}
		</Banner>
	)
}
